import { usePageMeta } from '../usePageMeta';
import { Hero } from './sections/Hero';
import { Proof } from './sections/Proof';
import { Services } from './sections/Services';
import { AgentDemo } from './sections/AgentDemo';
import { ProductsTeaser } from './sections/ProductsTeaser';
import { CaseStudies } from './sections/CaseStudies';
import { Testimonials } from './sections/Testimonials';
import { Process } from './sections/Process';
import { TechStack } from './sections/TechStack';
import { LatestNotes } from './sections/LatestNotes';
import { Faq } from './sections/Faq';
import { LeadCta } from './sections/LeadCta';

export function Landing(): React.JSX.Element {
  usePageMeta(
    'Inafana — AI agents & the software they run on',
    'Inafana builds agentic AI systems and RAG applications — plus the custom platforms they run on, from ERP to WhatsApp automation. 7+ years of international experience, everything shipped to production.',
  );

  return (
    <>
      <Hero />
      <Proof />
      <Services />
      <AgentDemo />
      <ProductsTeaser />
      <CaseStudies />
      <Testimonials />
      <Process />
      <TechStack />
      <LatestNotes />
      <Faq />
      <LeadCta />
    </>
  );
}
